import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/hooks/useToast';
import { oneOneOneReactQueryKeys } from 'screens/oneOnOneRabbit/InstancePage/constants/oneOnOneReactQueryKeys';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import { OneOnOneAgendaNotesI } from '../../Agenda/hooks/dataHooks';
import { getOneOnOneInstanceNotes, updateOneOnOneInstanceNotes } from '../services';

export const useOneOnOneNotesQuery = ({
  masterId,
  instanceId,
  isPrivate = false,
}: {
  masterId: number;
  instanceId?: number;
  isPrivate?: boolean;
}) =>
  useQuery(
    [oneOneOneReactQueryKeys.oneOnOneNotes, masterId, instanceId, isPrivate],
    () => getOneOnOneInstanceNotes({ masterId, instanceId, isPrivate })
    // {
    //   enabled: !!masterId
    // }
  );

export const useUpdateOneOnOneInstanceNotesMutation = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: async (notes: OneOnOneAgendaNotesI) =>
      await updateOneOnOneInstanceNotes({
        masterId,
        instanceId,
        isPrivate: notes.isPrivate,
        ...notes,
      }),
    onMutate: async (notes: OneOnOneAgendaNotesI) => {
      await queryClient.cancelQueries([oneOneOneReactQueryKeys.oneOnOneNotes, masterId, instanceId, notes.isPrivate]);

      const previousNotes = queryClient.getQueryData([
        oneOneOneReactQueryKeys.oneOnOneNotes,
        masterId,
        instanceId,
        notes.isPrivate,
      ]);

      queryClient.setQueryData([oneOneOneReactQueryKeys.oneOnOneNotes, masterId, instanceId, notes.isPrivate], notes);

      return { previousNotes };
    },
    onError: (err: { message: string }, variables, context) => {
      toast({
        title: err?.message || 'An unknown error has occurred, please try again',
        status: 'error',
      });
      queryClient.setQueryData(
        [
          oneOneOneReactQueryKeys.oneOnOneNotes,
          masterId,
          instanceId,
          //   @ts-ignore
          context.previousNotes.isPrivate,
        ],
        context.previousNotes
      );
    },
    onSuccess: () => {
      toast({
        title: 'Notes have been saved',
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries([oneOneOneReactQueryKeys.oneOnOneNotes]);
    },
  });
};
